import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _typeof from "@babel/runtime/helpers/esm/typeof";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import RelationSelector from '../util/relationSelector';
import { miloCore } from "@tencent/milo-core"; // import PROVINCE_DATA from './data.js';
// const PROVINCE_DATA = {};

var isDom = function isDom(obj) {
  try {
    return obj && _typeof(obj) === 'object' && obj.nodeType && obj.nodeType == 1 && obj.nodeName && typeof obj.nodeName === 'string';
  } catch (e) {
    // console.log(e)
    return false;
  }
};

var g = function g(id) {
  return document.getElementById(id);
};

var ProvinceCitySelectorComp = /*#__PURE__*/function () {
  function ProvinceCitySelectorComp(option) {
    _classCallCheck(this, ProvinceCitySelectorComp);

    this.option = _objectSpread({
      /**
             * @cfg {string} provinceId 省份的select dom id
             */
      provinceId: '',

      /**
             * @cfg {string} cityId 市区的select dom id
             */
      cityId: '',

      /**
             * @cfg {string} areaId 县区的select dom id
             */
      areaId: '',
      showLevel: 3,
      // 显示级别，默认为三级
      initVal: ['110000', '110000', '110101'],
      // 默认初始数据

      /**
             * @cfg {function} provinceChange 选择省份后的事件
             */
      provinceChange: function provinceChange() {},

      /**
             * @cfg {function} cityChange 选择市区后的事件，此方法的第一个参数会提供一对象{v : "",t:""}是选中的市的值和名称
             */
      cityChange: function cityChange() {},

      /**
             * @cfg {function} areaChange 选择区/县级后的事件，此方法的第一个参数会提供一对象{v : "",t:""}是选中的县的值和名称
             */
      areaChange: function areaChange() {},
      change: function change() {}
    }, option);
    this.getData();
  }

  _createClass(ProvinceCitySelectorComp, [{
    key: "getData",
    value: function getData() {
      var self = this;

      if (window.Milo_ProvinceCityData && window.Milo_ProvinceCityData.data) {
        self.init();
      } else {
        miloCore.loader.loadScript({
          url: 'https://ossweb-img.qq.com/images/js/milo_config_server/provincecity/latest/data.js',
          charset: "gb2312"
        }).then(function (isLoad) {
          if (isLoad) {
            self.init();
          }
        })["catch"](function (e) {
          console.log(e);
        });
      }
    }
    /**
    * 渲染省市数据
    * @param {object} opt 配置参数，详见配置
    * @return {undefined}
    */

  }, {
    key: "init",
    value: function init() {
      console.log(11, window.Milo_ProvinceCityData && window.Milo_ProvinceCityData.data || []);
      var _this$option = this.option,
          provinceId = _this$option.provinceId,
          cityId = _this$option.cityId,
          areaId = _this$option.areaId,
          showLevel = _this$option.showLevel,
          initVal = _this$option.initVal,
          provinceChange = _this$option.provinceChange,
          cityChange = _this$option.cityChange,
          areaChange = _this$option.areaChange,
          change = _this$option.change; // let l = 0;

      if (!provinceId || !cityId) return;
      if (!isDom(g(provinceId)) || !isDom(g(cityId))) return; // l = g(cityId).length;

      var arrSelectors = [];

      if (showLevel >= 1) {
        arrSelectors.push({
          ele: provinceId,
          // 绑定的元素
          keyShow: 't',
          // 每一个item显示的值
          keyValue: 'v',
          // 每一个item
          keySub: 'opt_data_array' // function(item){}

        });
      }

      if (showLevel >= 2) {
        arrSelectors.push({
          ele: cityId,
          // 绑定的元素
          keyShow: 't',
          // 每一个item显示的值
          keyValue: 'v',
          // 每一个item
          keySub: 'opt_data_array' // function(item){}

        });
      }

      if (showLevel >= 3) {
        arrSelectors.push({
          ele: areaId,
          // 绑定的元素
          keyShow: 't',
          // 每一个item显示的值
          keyValue: 'v',
          // 每一个item
          keySub: '' // function(item){}

        });
      }

      var RelationSelectorObj = new RelationSelector({
        selectors: arrSelectors,
        onChange: function onChange(values, order) {
          var showArr = RelationSelectorObj.getShowByVal(values);

          if (0 == order) {
            provinceChange({
              v: values[0],
              t: showArr[0]
            });
          } else if (1 == order) {
            cityChange({
              v: values[1],
              t: showArr[1]
            });
          } else if (2 == order) {
            areaChange({
              v: values[2],
              t: showArr[2]
            });
          } // change 接受 provinceObj   cityObj  areaObj


          var outRes = Array.from({
            length: showLevel
          }).map(function (item, i) {
            return {
              v: values[i],
              t: showArr[i]
            };
          });
          change.apply(null, outRes);
        },
        data: window.Milo_ProvinceCityData && window.Milo_ProvinceCityData.data || [],
        // 原始数据，array
        initVal: initVal
      });
    }
  }]);

  return ProvinceCitySelectorComp;
}();

export { ProvinceCitySelectorComp as default };
export var ProvinceCitySelector = {
  init: function init(option) {
    return new Promise(function (resolve, reject) {
      var instance;

      try {
        instance = new ProvinceCitySelectorComp(option);
        resolve(instance);
      } catch (e) {
        console.log(e);
        reject({
          errCode: -2,
          errMsg: '省市区模块初始化失败'
        });
      }
    });
  }
};